module.exports = __webpack_public_path__ + "efef392757f81a74cc0be1432f0a752d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/huagong_h.png
// module id = 277
// module chunks = 3